var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roy-designer-area",style:({
    left: _vm.start.x + 'px',
    top: _vm.start.y + 'px',
    width: _vm.width + 'px',
    height: _vm.height + 'px'
  })})}
var staticRenderFns = []

export { render, staticRenderFns }